<template>
    <div class="jr-component">
      <div class="jr-inputwhere">
        <span class="jr-display-name">
        {{ components.controlDisplayname }}
      </span>
      
      <el-input class="jr-input" v-bind="$attrs" :id="components.controlId" :size="size" v-model="componentValue.controlDefaultvalue" :disabled="!components.controlRighttype || components.controlReadonly" >
        <el-dropdown trigger="click" class="ainput-with-append" slot="append" :title="likeTypeTitle[nowLikeNum]">
          <span class="el-dropdown-link hand-pointer">
            {{ likeType[nowLikeNum] }}
          </span>
          <el-dropdown-menu slot="dropdown" >
            <div @click="nextLikeType" v-for="(like,i) in likeType" v-bind:key="like" :id="i"><el-dropdown-item >{{ likeTypeTitle[i] + '(' + like + ')' }}</el-dropdown-item></div>
          </el-dropdown-menu>
        </el-dropdown>
      </el-input>      
      <i @click="rightClick" v-if="badge & components.controlRighttype" class="el-icon-success jr-right-ico" style="color: green;"/>
      <i @click="rightClick" v-if="badge & !components.controlRighttype" class="el-icon-error jr-right-ico" style="color: red;"/> 
    </div>
    </div>
</template>
<script>
import JRGLOBAL from '@/api/jrglobal'
export default {
  name: 'JrInputwhere',
  computed: {
    componentValue: {
      get() {
        const nowLikeNum = this.likeType.indexOf(this.value.controlLiketype)
        if(nowLikeNum > 0){
          this.nowLikeNum = nowLikeNum
        }else{
          this.nowLikeNum = 0
        }
        return this.value
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  data() {
    return {
      likeType: JRGLOBAL.likeType,
      likeTypeTitle: JRGLOBAL.likeTypeTitle,
      nowLikeNum: 0,
    }
  },
  props: {
    value: {},
    badge: {
      type: Boolean,
      default: false
    },
    components: {},
    size: {
      type: String,
      default: 'small'
    }
    
  },
  methods: {
    rightClick(){
      this.$emit('badge-click', this.components.controlId, !this.components.controlRighttype)
    },
    nextLikeType(e) {      
      this.nowLikeNum = e.currentTarget.id
      this.componentValue.controlLiketype = this.likeType[this.nowLikeNum]
    },
  }
}

</script>
<style scoped lang="scss">
  .jr-display-name{
    width: 120px;
    text-align: right;
    vertical-align: middle;
    padding-right: 10px;
    color: #676767;
    display: inline-block; 

  }
  .jr-input{
    width: 190px;
  }
  .jr-inputwhere{
    display: flex;
    flex-direction: row ;
    justify-content: flex-start;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrInputwhere.vue